import { useParameter } from '../../../shared';

export function useDescription() {
  const description = [
    'Showing price index for soybean,rapeseed, wheat, corn and crude oil',
    'The base year for the index calculation can be selected',
    'Source: ICE, NYSE, USDA (Commodity Prices), US Energy Information Administration (Crude Oil)',
  ];
  return description;
}